var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / CSA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-CSA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#19BFBF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,16.3364563 C10,16.1506366 10.0358429,15.8566284 10.0817464,15.6730143 L10.5849202,13.660319 C10.6300675,13.4797298 10.7025096,13.1899618 10.7484131,13.0063477 L11.2515869,10.9936523 C11.2967342,10.8130631 11.2853883,10.5228316 11.2291667,10.3541667 L10.7708333,8.97916667 C10.7133037,8.80657768 10.533947,8.60030683 10.3707568,8.51871173 L9.62924321,8.14795494 C9.4658167,8.06624168 9.33333333,7.85662842 9.33333333,7.67301432 L9.33333333,5.66031901 C9.33333333,5.47972981 9.39969317,5.20061366 9.48128827,5.03742345 L9.85204506,4.29590988 C9.93375832,4.13248337 10.0663598,3.86728032 10.1479549,3.70409012 L10.5187117,2.96257655 C10.600425,2.79915003 10.818587,2.66666667 11.0077044,2.66666667 L14.3256289,2.66666667 C14.5139789,2.66666667 14.6666667,2.80935669 14.6666667,3.00312297 L14.6666667,3.6635437 C14.6666667,3.84936338 14.8093567,4 15.003123,4 L15.6635437,4 C15.8493634,4 16,4.14269002 16,4.3364563 L16,4.99687703 C16,5.18269672 16.1286189,5.39764277 16.3059006,5.48628362 L18.3607661,6.51371638 C18.5297103,6.59818849 18.6666667,6.80935669 18.6666667,7.00312297 L18.6666667,7.6635437 C18.6666667,7.84936338 18.6003068,8.13271968 18.5187117,8.29590988 L18.1479549,9.03742345 C18.0662417,9.20084997 17.8687744,9.42081706 17.7219086,9.51872762 L16.2780914,10.4812724 C16.1245058,10.5836628 15.9356906,10.7952855 15.8470497,10.9725672 L14.819617,13.0274328 C14.7351448,13.196377 14.5354411,13.4208171 14.3885752,13.5187276 L12.9447581,14.4812724 C12.7911724,14.5836628 12.6023572,14.7952855 12.5137164,14.9725672 L11.4862836,17.0274328 C11.4018115,17.196377 11.1906433,17.3333333 10.996877,17.3333333 L10.3364563,17.3333333 C10.1506366,17.3333333 10,17.1906433 10,16.996877 L10,16.3364563 Z",
    id: "Rectangle-1068",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsa);
export default __webpack_public_path__ + "static/media/CSA.680259363a8504d10e3e861151b0f5e3.svg";
export { ForwardRef as ReactComponent };